const TERMINAL_STATUSES = new Set(["Completed", "Canceled"])
const INVITE_EXPIRED_STATUS = "Invite Expired"

const normalizeStatus = status => status || ""

export const isStaffInvitationReady = order => {
  if (!order || order.awaitingModeration || !order.url || order.paidAt) {
    return false
  }

  const status = normalizeStatus(order.status)
  return status !== INVITE_EXPIRED_STATUS && !TERMINAL_STATUSES.has(status)
}

export const resolveBackgroundCheckCta = order => {
  if (isStaffInvitationReady(order)) {
    return {
      label: "Continue Background Check",
      action: "hire_right",
      url: order.url,
    }
  }

  if (order?.paidAt) {
    return {
      label: "Continue Background Check",
      action: "modal",
    }
  }

  return {
    label: "Start Background Check",
    action: "modal",
  }
}
